import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';

export const getSliderData = async () => {
    try {
        const response = await ApiClient.get(`/homePage/homePage/getSliderManagement`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const addSliderData = async ({ file, caption }) => {
    try {
        const response = await ApiClient.post(`/homePage/homePage/addSliderManagement`,
            { file, caption },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editSliderData = async ({ id, file, caption }) => {
    try {
        const response = await ApiClient.put(`/homePage/homePage/updateSliderManagement/${id}`,
            { file, caption, order: 1 },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteSliderData = async ({ id }) => {
    try {
        const response = await ApiClient.put(`/homePage/homePage/deleteSlider/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateSliderPriority = async ({ id, order }) => {
    try {
        const response = await ApiClient.put(`/homePage/homePage/updateSliderOrder/${id}`, 
            { order }, 
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        console.log("Priority update response:", response);
        return response;
    } catch (error) {
        throw error;
    }
};


